import type { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '../auth/auth-context';

export function PublicOnlyRoute({ children }: PropsWithChildren) {
  const { session, loading } = useAuth();

  if (loading) {
    return null;
  }
  if (session) {
    return <Navigate to="/" replace />;
  }
  return children;
}
